import React from 'react'
// import Binance from '../../assets/image 7.svg'
// import Gecko from '../../assets/image 8.svg'
import './partner.css'

const Partner = () => {
  return (
    <div className="bull3_partner-container">
      <div className="container-1">
        <div className="bull3_partner-roll">
          <p>Binance</p>
          <p>OppenZeppelin</p>
          <p>Unity</p>
          <p>IPFS</p>
        </div>
      </div>
    </div>
  )
}

export default Partner
